// extracted by mini-css-extract-plugin
var _1 = "PdfViewerSelectionAreaBox-modulePdfViewerSelectionAreaBox__XJZXk";
var _2 = "PdfViewerSelectionAreaBox-moduleicon__iec3F";
var _3 = "PdfViewerSelectionAreaBox-moduleiconWrapper__iPyQm";
export { _1 as "PdfViewerSelectionAreaBox", _2 as "icon", _3 as "iconWrapper" }
